import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Popconfirm } from "antd";
import { Button } from "react-bootstrap";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import scheduleMods from "data/schedule-mods";
import exportFromBlob from "helpers/export-from-blob";
import UserTypes from "components/auth/user-types";
import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";

// import CreateService from "components/menu/scheduling/modals/create-service";
const CreateService = React.lazy(() =>
    import("components/menu/scheduling/modals/create-service"));

class ListButtons extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleExportData = this.handleExportData.bind(this);
        this.handleCreateService = this.handleCreateService.bind(this);
    }

    handleExportData = () => {
        this.props.handleExport(schedulesForExport => {
            const fileName = `schedules-${moment().format("YYYY-MM-DD")}.xlsx`;
            exportFromBlob(schedulesForExport, fileName);
        });
    };

    handleCreateService = () => {
        const modalObj = {
            id: "create-service",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20
                },
            },
            header: "Create Service",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <CreateService
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSuccess={() => {
                            this.props.onServiceCreateSuccess();
                            this.props.closeCustomModal(modalObj);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            userRole,
            handleActivate,
            handleDeactivate,
            handleDelete,
            handleHighlight,
            mode,
            totalFilteredRecords
        } = this.props;

        const isAdmin = userRole.includes(UserTypes.admin);
        const showActivate = [scheduleMods.NotActivated.value].indexOf(mode) > -1;
        const showDeactivate = [
            scheduleMods.Open.value,
            scheduleMods.ComingDue.value
        ].indexOf(mode) > -1;

        const showHighlight = [scheduleMods.NotActivated.value].indexOf(mode) > -1;

        const dangerIcon = (
            <FontAwesomeIcon
                icon="info-circle"
                size="lg"
                className="text-danger position-absolute"
            />
        );

        return (
            <div className="d-flex justify-content-between mt-3 mb-3">
                <div>
                    <Button
                        variant="primary mr-2"
                        onClick={this.handleExportData}
                    >
                        Download excel
                    </Button>

                    {isAdmin && showActivate ?
                        <Popconfirm
                            overlayClassName="confirm-with-reverse-buttons"
                            icon={dangerIcon}
                            title={
                                <div className="text-danger">
                                    You are about to activate {totalFilteredRecords} services.
                                    <br/>
                                    <div className="text-right">Continue?</div>
                                </div>
                            }
                            onConfirm={handleActivate}
                            placement="topRight"
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button variant="warning mr-2">
                                Activate Filtered
                            </Button>
                        </Popconfirm>
                        : null}

                    {isAdmin && showDeactivate ?
                        <Popconfirm
                            overlayClassName="confirm-with-reverse-buttons"
                            icon={dangerIcon}
                            title={
                                <div className="text-danger">
                                    You are about to deactivate {totalFilteredRecords} services.
                                    <br/>
                                    <div className="text-right">
                                        Continue?
                                    </div>
                                </div>
                            }
                            onConfirm={handleDeactivate}
                            placement="topRight"
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button
                                variant="warning mr-2"
                            >
                                Deactivate Filtered
                            </Button>
                        </Popconfirm>
                        : null}

                    {!isAdmin ||
                    <Popconfirm
                        overlayClassName="confirm-with-reverse-buttons"
                        icon={dangerIcon}
                        title={
                            <div className="text-danger">
                                You are about to delete {totalFilteredRecords} services.
                                <br/>
                                <div className="text-right">Continue?</div>
                            </div>
                        }
                        onConfirm={handleDelete}
                        placement="topRight"
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button variant="danger mr-2">
                            Delete Filtered
                        </Button>
                    </Popconfirm>
                    }

                    {isAdmin && showHighlight ?
                    <Popconfirm
                        overlayClassName="confirm-with-reverse-buttons"
                        icon={dangerIcon}
                        title={
                            <div className="text-danger">
                                You are about to highlight {totalFilteredRecords} services.
                                <br/>
                                <div className="text-right">Continue?</div>
                            </div>
                        }
                        onConfirm={handleHighlight}
                        placement="topRight"
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button variant="info mr-2">
                            Highlight Filtered
                        </Button>
                    </Popconfirm>
                    : null}
                </div>
                <div>
                    {userRole.includes(UserTypes.admin)
                    || userRole.includes(UserTypes.accountManager) ?
                    <button
                        className="btn btn-primary"
                        onClick={this.props.onEmailBlasterClick}
                    >
                        Email Blaster
                    </button>
                    : null}

                    {!isAdmin ||
                        <Button
                            variant="success ml-2"
                            onClick={this.handleCreateService}
                        >
                            Create Service
                        </Button>
                    }
                </div>
            </div>
        );
    }
}

ListButtons.propTypes = {
    mode: PropTypes.string.isRequired,
    totalFilteredRecords: PropTypes.number.isRequired,
    handleActivate: PropTypes.func.isRequired,
    handleDeactivate: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleHighlight: PropTypes.func.isRequired,
    handleExport: PropTypes.func.isRequired,
    onServiceCreateSuccess: PropTypes.func.isRequired,
    onEmailBlasterClick: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    userRole: state.auth.user.role
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ListButtons);
